import { TopicScore } from "../atlas/components/SummaryTopicCard/summaryTopicCardTypes";

export const categorizeScores = (topicScores: TopicScore[]) => {
  const strongTopics = topicScores.filter((topic: TopicScore) => topic.averageScore >= 80);
  const fairTopics = topicScores.filter(
    (topic: TopicScore) => topic.averageScore >= 60 && topic.averageScore < 80
  );
  const poorTopics = topicScores.filter((topic: TopicScore) => topic.averageScore < 60);
  return { poorTopics, strongTopics, fairTopics };
};
